import { H4, MainButton, MainModal, P1 } from '@moneymade/moneymade-ui'
import PropTypes from 'prop-types'

import styles from './InfoModal.module.scss'

const InfoModal = ({ isOpen, data: { title, text }, handleClose }) => (
  <MainModal
    className={styles.InfoModal}
    maxWidth={600}
    shape="rounded"
    isOpen={isOpen}
    verticalPosition="center"
    handleClose={handleClose}
    header={
      title && (
        <H4 type="main" weight="semibold">
          {title}
        </H4>
      )
    }
    footer={
      <div className={styles.OkBtn}>
        <MainButton fontType="main" weight="light" onClick={handleClose}>
          Okay
        </MainButton>
      </div>
    }
  >
    {text && <P1 className="rte" nestedStyles dangerouslySetInnerHTML={{ __html: text }} />}
  </MainModal>
)

InfoModal.propTypes = {
  isOpen: PropTypes.bool,
  data: PropTypes.shape({
    title: PropTypes.string,
    text: PropTypes.string
  }),
  handleClose: PropTypes.func
}

InfoModal.defaultProps = {
  isOpen: false,
  data: {
    title: '',
    text: ''
  },
  handleClose: () => {}
}

export default InfoModal
